// src/routes/PrivateRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { temSessaoAtiva } from "../util/libLocalStorage";

export default function PrivateRoute() {
	const logado = temSessaoAtiva();
	return logado ? <Outlet /> : <Navigate to="/login" replace />;
}
